<p-header>
  @if (!isAnswerMode) {
    <i-title styleClass="w-100" [text]="'createCourrier.createMail' | translate" [buttons]="titleButtons" level="1"></i-title>
  }
  @if (isAnswerMode) {
    <i-title styleClass="w-100" [text]="'createCourrier.createMail' | translate" [buttons]="titleButtons" level="1"></i-title>
    <h4 class="custom-h4-title mt-2" id="answerTo">
      {{ 'createCourrier.inResponseToMail' | translate }} #{{ mailId | separateNumberWithCharacters }}
    </h4>
  }
</p-header>
@if (!isAnswerMode) {
  <div>
    <div class="modal-body setOverflow">
      <app-courrier-edition-form
        [scan]="scan"
        [serviceProprietaireId]="serviceProprietaireId"
        (isFormValid)="receiveFormValidSt($event)"
        [isNew]="true"
        [globalSubmitE]="globalSubmitESubject.asObservable()"
        (canSubmit)="canSubmitReceived($event)"
        (formState)="receiveFormState($event)"
        [courrierFile]="courrierFile"
        (newMail)="receiveNewMail($event)"
        [mailType]="mailType">
      </app-courrier-edition-form>
    </div>
  </div>
}
@if (isAnswerMode) {
  <div>
    <div class="modal-body setOverflow">
      <app-courrier-edition-form
        (isFormValid)="receiveFormValidSt($event)"
        [isNew]="true"
        [globalSubmitE]="globalSubmitESubject.asObservable()"
        (canSubmit)="canSubmitReceived($event)"
        (formState)="receiveFormState($event)"
        [mailId]="mailId"
        [isAnswerMode]="isAnswerMode"
        (newMail)="receiveNewMail($event)"
        [expediteurId]="expediteurId"
        [mailType]="defaultTypeES"></app-courrier-edition-form>
    </div>
  </div>
}

<p-confirmDialog
  #cd
  key="CloseModal"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
